import React from 'react';
import classnames from 'classnames';
import { Skeleton } from '@mui/material';

import s from './DocEditor.module.scss';

const DocEditorSkeleton = () => {
  return (
    <section className={s.container}>
      <div className="detail-row">
        <div className="detail-col">
          <div
            className="doc-editor-header"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 'var(--spacing-lg)',
            }}
          >
            <h2>Documentation</h2>
          </div>
          <div className={classnames(s.docSkeleton, 'doc-editor-container')}>
            <div className={s.docSkeletonSection}>
              <Skeleton variant="text" animation="wave" width="20%" />
              <Skeleton variant="text" animation="wave" width="95%" />
              <Skeleton variant="text" animation="wave" width="75%" />
            </div>
            <div className={s.docSkeletonSection}>
              <Skeleton variant="text" animation="wave" width="18%" />
              <Skeleton variant="text" animation="wave" width="85%" />
              <Skeleton variant="text" animation="wave" width="90%" />
            </div>
            <div className={s.docSkeletonSection}>
              <Skeleton variant="text" animation="wave" width="10%" />
              <Skeleton variant="text" animation="wave" width="92%" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DocEditorSkeleton;
